import React, { FC } from 'react';

import { Modal } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

import { UserPreferencesForm } from './UserPreferencesForm';
import './UserPreferencesModal.styles.scss';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const UserPreferencesModal: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslate();

  return (
    <Modal
      open={open}
      onClose={onClose}
      modalHeaderProps={{
        title: t('settings.userPreferences'),
        message: t('settings.quicklyEditYourPersonalInformationHere'),
        onClose,
      }}
    >
      <UserPreferencesForm
        showButtons
        onCancel={onClose}
        onSubmit={onClose}
        classes={{
          wrapper: 'user-preferences-modal-wrapper',
          input: 'user-preferences-input',
          buttons: 'justify-content-end',
        }}
      />
    </Modal>
  );
};
